import { render, staticRenderFns } from "./modify-data-compliance-config.vue?vue&type=template&id=3ef84f1e&scoped=true"
import script from "./modify-data-compliance-config.vue?vue&type=script&lang=ts"
export * from "./modify-data-compliance-config.vue?vue&type=script&lang=ts"
import style0 from "./modify-data-compliance-config.vue?vue&type=style&index=0&id=3ef84f1e&prod&lang=less&scoped=true"
import style1 from "./modify-data-compliance-config.vue?vue&type=style&index=1&id=3ef84f1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef84f1e",
  null
  
)

export default component.exports